// dependencies
import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { parseISO, format, isBefore } from "date-fns";
import { Link } from "yarrr";

// components
import CompanyLogo from "Components/CompanyLogo";

// css
import css from "./Company.styl";

const getExpirationDate = (expires) => {
	// parseISO returns "Invalid Date" if the string is not a
	// valid ISO 8601 date string https://date-fns.org/v2.21.1/docs/parseISO
	const parseResult = parseISO(expires);
	if (parseResult.toString() === "Invalid Date") return null;
	return parseResult;
};

const Company = ({ company }) => {
	const now = new Date();
	const expirationDate = getExpirationDate(company.get("expires"));
	const isExpired = expirationDate ? isBefore(expirationDate, now) : false;

	return (
		<Link
			href={`/companies/${company.get("id")}/`}
			className={`${css.Company} ${isExpired ? css.isExpired : ""}`}
			style={{ backgroundColor: company.getIn(["branding", "navigationColor"]) }}
		>
			<div className={css.companyLogoWrapper}>
				<CompanyLogo className={css.logo} size={50} companyID={company.get("id")} />
			</div>

			<div className={css.companyData} style={{ color: company.getIn(["branding", "iconColor"]) }}>
				<div className={css.companyName}>{company.get("name")}</div>
				{expirationDate && (
					<div className={`${css.companyExpires}`}>
						{format(expirationDate, "MMM d yyyy, h:mm a")} {isExpired ? "( expired )" : ""}
					</div>
				)}
			</div>
		</Link>
	);
};

Company.propTypes = {
	company: PropTypes.instanceOf(Map).isRequired,
};

export default Company;
